import { FormattedMessage } from 'react-intl';
import React, { forwardRef, useState } from 'react';
import { Box, Button, Collapse } from '@mui/material';
import {
  CRUD_COMPONENT_TYPE,
  CRUDComponent,
  Label,
  SubSection,
  useDataProvider,
} from '@ui-framework/index';
import Grid2 from '@thirdparty-framework/mui/material/Grid';
import { useFormContext } from 'react-hook-form';
import {
  claimNumber,
  serviceCompletionDate,
  serviceProvider,
  servicePerformed,
  totalApproved,
} from './accessorFunctions';
import PageSection from '../../../PageSection';
import listSchema from './schemas/list.json';
import CloseButton from '../CloseButton';

const ClaimsServiceHistory = forwardRef((props, ref) => {
  const { getValues } = useFormContext();
  const serviceJobId = getValues('id');
  const [open, setOpen] = useState(true);

  const provider =
    process.env.NODE_ENV === 'development' ? 'sxclServices' : 'default';
  const dataProvider = useDataProvider(provider);

  const listApiUrl = `${dataProvider.getApiUrl()}/sxcl/v1/service-jobs/${serviceJobId}/claims/service-history`;

  const listProps = {
    columnPrimaryId: 'id',
    storeName: 'ClaimInProcess',
    dataProvider,
    schema: listSchema,
    initialState: {
      showColumnFilters: false,
    },
    downloadApiUrl: null,
    listApiUrl,
    accessorFunctions: {
      claimNumber,
      serviceCompletionDate,
      serviceProvider,
      servicePerformed,
      totalApproved,
    },
    sortBy: 'serviceCompletionDate',
    SortOrder: 'DESC',
  };

  const handleToggle = e => {
    e.preventDefault();
    setOpen(prev => !prev);
  };

  return (
    <Box ref={ref}>
      {!open && (
        <Button onClick={handleToggle} variant="text">
          <FormattedMessage id="VIEW_CLAIMS" defaultMessage="View Claims" />
        </Button>
      )}
      <Collapse in={open}>
        <SubSection>
          <Grid2 container>
            <Grid2 xs={8}>
              <Label>
                <FormattedMessage id="CLAIMS" defaultMessage="Claims" />
              </Label>
            </Grid2>
            <Grid2 xs={4} textAlign="right">
              <CloseButton onClose={() => setOpen(false)} />
            </Grid2>
          </Grid2>

          <Box mt={2}>
            <PageSection containerProps={{ sx: { mt: -2 } }}>
              <Box>
                <CRUDComponent
                  type={CRUD_COMPONENT_TYPE.SEMI_ADVANCED_LIST}
                  listProps={listProps}
                />
              </Box>
            </PageSection>
          </Box>
        </SubSection>
      </Collapse>
    </Box>
  );
});

export default ClaimsServiceHistory;
